import React from 'react';
import { ChevronRight, ChevronLeft } from 'lucide-react';

const Navigation = ({ 
  currentStep, 
  canProceed, 
  onNext, 
  onPrev, 
  buttonText = 'Siguiente',
  showIcon = true 
}) => {
  return (
    <div className="flex justify-between items-center mt-8">
      <button
        onClick={onPrev}
        disabled={currentStep === 0}
        className={`flex items-center gap-2 px-6 py-3 rounded-xl font-semibold transition-all duration-300 ${
          currentStep === 0
            ? 'bg-gray-800 text-gray-600 cursor-not-allowed'
            : 'bg-gray-800 text-gray-300 hover:bg-gray-700 hover:text-yellow-500'
        }`}
      >
        <ChevronLeft className="w-5 h-5" />
        Anterior
      </button>

      <button
        onClick={onNext}
        disabled={!canProceed}
        className={`flex items-center gap-2 px-6 py-3 rounded-xl font-semibold transition-all duration-300 ${
          canProceed
            ? 'bg-gradient-to-r from-yellow-500 to-yellow-600 hover:from-yellow-600 hover:to-yellow-700 text-black shadow-lg hover:shadow-yellow-500/50 transform hover:scale-105'
            : 'bg-gray-800 text-gray-600 cursor-not-allowed'
        }`}
      >
        {buttonText}
        {showIcon && <ChevronRight className="w-5 h-5" />}
      </button>
    </div>
  );
};

export default Navigation;